import { Link } from 'react-router-dom';

import { ROUTE_SIMILARITIES } from 'CorePackage/MainModule/routes/routes';
import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';

interface ISimilaritiesLink {
  id: string | number;
}

export function SimilaritiesLinkCell<T extends ISimilaritiesLink>({ value, row }: ITableRenderCell<T>) {
  const { id } = row;

  return (
    <Link
      className="shared-table-link"
      target="_blank"
      to={{ pathname: `${ROUTE_SIMILARITIES}/${id}`, search: `${value}` }}
    >
      {value}
    </Link>
  );
}
